import { render, staticRenderFns } from "./NotificationProfileList.vue?vue&type=template&id=04ab2888&scoped=true&"
import script from "./NotificationProfileList.vue?vue&type=script&lang=js&"
export * from "./NotificationProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab2888",
  null
  
)

export default component.exports